var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpenIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4336_37351)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.0959 16.3356C34.7835 15.9971 27.2691 8.03516 17.8572 8.03516C8.44536 8.03516 0.93102 15.9971 0.61855 16.3356C0.270054 16.714 0.270054 17.286 0.61855 17.6644C0.93102 18.0029 8.44549 25.9648 17.8572 25.9648C27.2689 25.9648 34.7834 18.0029 35.0959 17.6644C35.4443 17.286 35.4443 16.714 35.0959 16.3356ZM17.8572 23.9727C13.8998 23.9727 10.6795 20.8443 10.6795 17C10.6795 13.1557 13.8998 10.0273 17.8572 10.0273C21.8146 10.0273 25.0349 13.1557 25.0349 17C25.0349 20.8443 21.8146 23.9727 17.8572 23.9727Z",
    fill: "#781D7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8826 15.0078C18.8826 14.0057 19.3946 13.1242 20.1737 12.582C19.4746 12.2344 18.6949 12.0195 17.8572 12.0195C15.0303 12.0195 12.7302 14.2539 12.7302 17C12.7302 19.7461 15.0303 21.9805 17.8572 21.9805C20.3881 21.9805 22.4829 20.1852 22.8968 17.8395C20.8319 18.4853 18.8826 16.9683 18.8826 15.0078Z",
    fill: "#781D7E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4336_37351"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 34,
    fill: "white",
    transform: "translate(0.357178)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenIcon);
export default __webpack_public_path__ + "static/media/OpenIcon.7efa70c6d5c416a526056a0f86bc2201.svg";
export { ForwardRef as ReactComponent };